import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  CONSTANTE_ID_COMBO_COTITULAR,
  DIRECT_DEBIT,
  FORM_AUTO,
  FORM_BP,
  FORM_CONSUMO,
  FORM_MG,
  FORM_MG_NO_SHOP,
  INTERVINIENTE_1_DIRECT_DEBIT,
  INTERVINIENTE_2_DIRECT_DEBIT,
  INTERVINIENTE_3_DIRECT_DEBIT,
  INTERVINIENTE_4_DIRECT_DEBIT,
  INTERVINIENTE_AVALISTA,
  INTERVINIENTE_COTITULAR,
  INTERVINIENTE_TITULAR,
  PENDIENTES_DE_DATOS,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_VIEW,
} from '@app/@core/constants/requests.constants';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { createMask } from '@ngneat/input-mask';
import { Participant, StatesFieldsFrontDTO } from '@app/requests/model/requests-model';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';

@Component({
  selector: 'scf-direct-debit',
  templateUrl: './direct-debit.component.html',
  styleUrls: ['./direct-debit.component.scss'],
})
export class DirectDebitComponent implements OnInit {
  public directDebitForm: FormGroup;
  ownershipList: CommonDataDTO[] = [];
  @Input() public interviniente: Participant;
  @Input() public mode: string = 'new';
  @Input() state: CommonDataDTO;
  @Input() public request: any = null;
  @Input() public disabledOwnershipCombo: any;
  @Input() public numInterviniente: string;
  @Input('operative') set operative(data: any) {
    if (data) {
      if (data === 'EIC' && this.requestStore.listaFormulariosConsumo.includes(this.directDebitForm)) {
        this.requestStore.listaFormulariosConsumo[DIRECT_DEBIT] = null;
      } else if (data !== 'EIC' && !this.requestStore.listaFormulariosConsumo.includes(this.directDebitForm)) {
        this.requestStore.setFormularioConsumo(this.directDebitForm, DIRECT_DEBIT);
      }
    }
  }
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() public isFinishedLoading = new EventEmitter<any>();

  licenseInputMask = createMask({
    mask: '99 9999 9999 9999 9999 9999',
  });

  hideOwnershipCombo: boolean = false;

  //PE_725 Fenix
  fieldsDisabled: StatesFieldsFrontDTO[];

  constructor(
    private formBuilder: FormBuilder,
    private requestStore: RequestsSaveSendStore,
    private combosStore: CombosStore,
    private customValidatorsService: CustomValidatorsService
  ) {}

  ngOnInit() {
    this.directDebitForm = this.formBuilder.group({
      ownershipCombo: ['', [this.customValidatorsService.isRequired]],
      numberCreditAccount: ['', !this.interviniente ? Validators.required : null],
      remember: true,
    });

    this.combosStore.ownershipList$.subscribe((valor: CommonDataDTO[]) => {
      if (valor) {
        const brand = this.requestStore.getMarcaFormulario();
        if (brand === FORM_BP || brand === FORM_MG || brand === FORM_MG_NO_SHOP) {
          const holder = valor.find((ownership) => ownership.id === INTERVINIENTE_TITULAR);
          if (holder) {
            this.ownershipList = [];
            this.ownershipList.push(holder);
          }
        } else {
          this.ownershipList = valor;
        }
        if (this.ownershipList.length === 1) {
          this.directDebitForm.controls.ownershipCombo.setValue(this.ownershipList[0].id);
        }
      }
    });

    if (this.requestStore.getMarcaFormulario() === FORM_BP) {
      this.requestStore.setFormularioBonpreu(this.directDebitForm, DIRECT_DEBIT);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG_NO_SHOP) {
      this.requestStore.setFormularioMangoNoShopping(this.directDebitForm, DIRECT_DEBIT);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.directDebitForm, DIRECT_DEBIT);
    } else if (
      this.requestStore.getMarcaFormulario() === FORM_CONSUMO ||
      this.requestStore.getMarcaFormulario() === FORM_AUTO
    ) {
      let isConsumo = this.requestStore.getMarcaFormulario() === FORM_CONSUMO;
      if (this.interviniente) {
        switch (this.interviniente.id) {
          case 1:
            isConsumo
              ? this.requestStore.setFormularioConsumo(this.directDebitForm, INTERVINIENTE_1_DIRECT_DEBIT)
              : this.requestStore.setFormularioAutos(this.directDebitForm, INTERVINIENTE_1_DIRECT_DEBIT);
            break;
          case 2:
            this.requestStore.setFormularioAutos(this.directDebitForm, INTERVINIENTE_2_DIRECT_DEBIT);
            break;
          case 3:
            this.requestStore.setFormularioAutos(this.directDebitForm, INTERVINIENTE_3_DIRECT_DEBIT);
            break;
          case 4:
            this.requestStore.setFormularioAutos(this.directDebitForm, INTERVINIENTE_4_DIRECT_DEBIT);
            break;
          default:
            console.error('Interviniente Not found!');
        }
      } else {
        isConsumo
          ? this.requestStore.setFormularioConsumo(this.directDebitForm, DIRECT_DEBIT)
          : this.requestStore.setFormularioAutos(this.directDebitForm, DIRECT_DEBIT);
      }
    }

    this.directDebitForm.statusChanges.subscribe(() => {
      this.emitStatusForm();
    });

    if (this.mode === REQUEST_MODE_VIEW) {
      if (this.state.id !== PENDIENTES_DE_DATOS) {
        this.directDebitForm.disable();
      }
      this.setValuesToForm();
    } else if (this.mode === REQUEST_MODE_EDIT) {
      this.setValuesToForm();
    }

    this.emitStatusForm();
    this.isFinishedLoading.emit({ formID: DIRECT_DEBIT, value: true });
  }

  ngAfterContentChecked() {
    //PE_725 Fenix
    if (this.mode === REQUEST_MODE_EDIT && this.request !== null && this.request.fieldsDisable !== null) {
      this.fieldsDisabled = this.request.fieldsDisable;
      this.disableFieldsByCore();
    }
  }

  private emitStatusForm() {
    if (this.interviniente) {
      switch (this.interviniente.id) {
        case 1:
          this.changeContinueStatus.emit({ form: <FormGroup>this.directDebitForm, id: INTERVINIENTE_1_DIRECT_DEBIT });
          break;
        case 2:
          this.changeContinueStatus.emit({ form: <FormGroup>this.directDebitForm, id: INTERVINIENTE_2_DIRECT_DEBIT });
          break;
        case 3:
          this.changeContinueStatus.emit({ form: <FormGroup>this.directDebitForm, id: INTERVINIENTE_3_DIRECT_DEBIT });
          break;
        case 4:
          this.changeContinueStatus.emit({ form: <FormGroup>this.directDebitForm, id: INTERVINIENTE_4_DIRECT_DEBIT });
          break;
        default:
          console.error('Interviniente Not found!');
      }
    } else {
      this.changeContinueStatus.emit({ form: <FormGroup>this.directDebitForm, id: DIRECT_DEBIT });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabledOwnershipCombo?.currentValue) {
      if (this.disabledOwnershipCombo?.id === this.interviniente?.id) {
        if (this.directDebitForm && this.disabledOwnershipCombo?.value) {
          this.directDebitForm.controls.ownershipCombo.setValue(null);
          this.directDebitForm.controls.ownershipCombo.clearValidators();
          this.directDebitForm.controls.ownershipCombo.disable();
          this.hideOwnershipCombo = true;
        } else {
          this.directDebitForm?.controls.ownershipCombo.enable();
          this.directDebitForm?.controls.ownershipCombo.setValidators([this.customValidatorsService.isRequired]);
          this.hideOwnershipCombo = false;
        }
        this.emitStatusForm();
      }
    }
  }

  updateIban(value: string) {
    const regex = /^[0-9]*$/;
    const numberAccount = value.replace(/\s+/g, '');
    let invalid = this.validateIban('ES' + numberAccount);

    if (numberAccount.length === 22 && regex.test(numberAccount)) {
      this.directDebitForm.controls.numberCreditAccount.setValue(value);
    }

    if (invalid.invalidIban) {
      this.directDebitForm.controls.numberCreditAccount.setErrors({ invalid: true });
    } else {
      this.directDebitForm.controls.numberCreditAccount.setErrors(null);
    }
  }

  validateIban(iban: any): { [key: string]: any } {
    let value = iban;
    if (!value) {
      return null;
    }

    let parsedValue: string = String(value);
    let invalid: boolean = false;

    // iban should be at least 15 characters long
    if (parsedValue.length < 15) {
      return { invalidIban: true };
    }

    // test for illegal characters
    let regexp = new RegExp('^[a-zA-Z0-9]+$');
    if (regexp.test(parsedValue) == false) {
      return { invalidIban: true };
    }

    // move the first four characters to the back and make sure everything is uppercase
    parsedValue = (parsedValue.substr(4) + parsedValue.substr(0, 4)).toUpperCase();
    let valueWithConvertedNumbers: string = '';
    for (var i = 0; i < parsedValue.length; i++) {
      let character: number = parsedValue.charCodeAt(i);

      // If the character is A-Z, we need to convert it to a number from 10-35
      if (character > 64 && character < 91) {
        valueWithConvertedNumbers += String(character - 55);
      } else {
        valueWithConvertedNumbers += String.fromCharCode(character);
      }
    }

    let modulo = this.modulo(valueWithConvertedNumbers, 97);
    if (modulo !== 1) {
      return { invalidIban: true };
    }

    return { invalidIban: false };
  }

  modulo(divident: any, divisor: any): number {
    let partLength = 10;

    while (divident.length > partLength) {
      var part = divident.substring(0, partLength);
      divident = (part % divisor) + divident.substring(partLength);
    }

    return divident % divisor;
  }

  setValuesToForm() {
    if (this.request) {
      this.directDebitForm.controls.ownershipCombo.setValue(
        this.request.accountHolding === '0' ? '' : this.request.accountHolding
      );

      this.directDebitForm.controls.numberCreditAccount.setValue(
        this.request.iban?.substr(2) +
          this.request.entityBank +
          this.request.officeBank +
          this.request.dcBank +
          this.request.numberBank
      );
      if (this.interviniente?.request?.typeCoHolder === INTERVINIENTE_AVALISTA) {
        this.directDebitForm.controls.ownershipCombo.setValue(null);
        this.directDebitForm.controls.ownershipCombo.clearValidators();
        this.directDebitForm.controls.ownershipCombo.disable();
        this.hideOwnershipCombo = true;
      } else if (this.interviniente?.request?.typeCoHolder === INTERVINIENTE_COTITULAR) {
        this.directDebitForm.controls.ownershipCombo.setValue(CONSTANTE_ID_COMBO_COTITULAR);
      } else {
        this.directDebitForm.controls.ownershipCombo.setValue(INTERVINIENTE_TITULAR);
      }
    }
  }

  private disableFieldsByCore() {
    if (this.fieldsDisabled !== null && this.fieldsDisabled !== undefined) {
      const form = this.directDebitForm;
      this.fieldsDisabled.forEach((field) => {
        const toDisable = form.get(field.campoName);
        if (toDisable !== null && toDisable !== undefined) {
          toDisable.disable();
        }
      });
    }
  }
}
